(function (angular, app) {
   "use strict";

   // Heading
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.inlinealert, InlineAlertDirective);

   InlineAlertDirective.$inject = [];

   function InlineAlertDirective() {
      return {
         restrict: "E"
         , templateUrl: "app/ui/directives/alert-inline.html"

      }
   }


}(angular, app));
